import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { IconFaceSmile } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import ToolboxButtonWithPopup from '../../../base/toolbox/components/web/ToolboxButtonWithPopup';
import { toggleReactionsMenuVisibility } from '../../actions.web';
import { getReactionsMenuVisibility } from '../../functions.web';
import { IReactionsMenuParent } from '../../types';
import ReactionsMenu from './ReactionsMenu';
/**
 * Implementation of a button for emoji reactions.
 */
class EmojiButtonImpl extends AbstractButton {
    accessibilityLabel = 'toolbar.accessibilityLabel.reactions';
    icon = IconFaceSmile;
    label = 'toolbar.reactions';
    toggledLabel = 'toolbar.reactions';
    tooltip = 'toolbar.reactions';
}
const EmojiButtonComponent = translate(EmojiButtonImpl);
/**
 * Emoji button that opens reactions menu popup.
 *
 * @returns {ReactElement}
 */
const EmojiButton = ({ buttonKey, notifyMode }) => {
    const dispatch = useDispatch();
    const isOpen = useSelector((state) => getReactionsMenuVisibility(state));
    const toggleReactionsMenu = useCallback(() => {
        dispatch(toggleReactionsMenuVisibility());
    }, [dispatch]);
    const openReactionsMenu = useCallback(() => {
        !isOpen && toggleReactionsMenu();
    }, [isOpen, toggleReactionsMenu]);
    const closeReactionsMenu = useCallback(() => {
        isOpen && toggleReactionsMenu();
    }, [isOpen, toggleReactionsMenu]);
    const reactionsMenu = (React.createElement("div", { className: 'reactions-menu-container' },
        React.createElement(ReactionsMenu, { parent: IReactionsMenuParent.Button })));
    return (React.createElement("div", { className: 'reactions-menu-popup-container' },
        React.createElement(ToolboxButtonWithPopup, { ariaLabel: 'toolbar.accessibilityLabel.reactionsMenu', onPopoverClose: closeReactionsMenu, onPopoverOpen: openReactionsMenu, popoverContent: reactionsMenu, visible: isOpen },
            React.createElement(EmojiButtonComponent, { buttonKey: buttonKey, notifyMode: notifyMode }))));
};
export default EmojiButton;
